export default __webpack_public_path__ + "static/media/doc.864775cd.svg";